import get from 'lodash/get';
export const getCurrentLanguage = props => {
  return get(props, 'sitecoreContext.language', '');
}